import { render, staticRenderFns } from "./PeppolSetup.vue?vue&type=template&id=352cc348&scoped=true"
import script from "./PeppolSetup.vue?vue&type=script&lang=ts"
export * from "./PeppolSetup.vue?vue&type=script&lang=ts"
import style0 from "./PeppolSetup.vue?vue&type=style&index=0&id=352cc348&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352cc348",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352cc348')) {
      api.createRecord('352cc348', component.options)
    } else {
      api.reload('352cc348', component.options)
    }
    module.hot.accept("./PeppolSetup.vue?vue&type=template&id=352cc348&scoped=true", function () {
      api.rerender('352cc348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/init-modal/PeppolSetup.vue"
export default component.exports